import {
  Link as ChakraLink,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  ModalProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import { Link as ReactRouterLink, useNavigate } from "react-router-dom";
import { ListLoginTypeCard } from "../card/ListLoginTypeCard";
import { ModalTitle } from "../card/ModalTitle";

interface Props extends ModalProps {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const LoginModal = ({ isOpen, onOpen, onClose }: Props) => {
  const navigate = useNavigate();

  const handleClick = (link: string) => {
    navigate(link);
  };

  return (
    <Modal
      isCentered
      size={["xl", null, "2xl"]}
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody textAlign={"center"}>
          <VStack w={"100%"}>
            <ModalTitle
              title="Masuk ke akun anda"
              subtitle="Masuk dengan memilih sesuai dengan tipe akun anda"
            />

            <ListLoginTypeCard
              onClick={(id, link) => {
                handleClick(link);
              }}
            />

            <ModalFooter gap={2}>
              <Text textStyle={"b-sm"}>Belum mempunyai akun? </Text>

              <ChakraLink
                as={ReactRouterLink}
                to={"/register"}
                variant={"linkPrimary"}
                fontSize={[10, null, 12]}
                color={"red.400"}
              >
                Daftar
              </ChakraLink>
            </ModalFooter>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default LoginModal;
